"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = init;
/*
 * Client bootstrap: auth header widgets only. The legacy viz/status/issue-assignees
 * renderers were removed 2026-07-02 — every visualization is now an inline v2 partial
 * fetching /v2/metrics/* (see views/partials/v2-*.hbs).
 */
const myself_1 = require("@uvasomit/myself");
const base = document.querySelector('body').getAttribute('data-m-path');
const authBase = document.querySelector('body').getAttribute('data-m-auth');
const TOKEN_KEY = 'uvasom.dev.jwt';
function init(apiUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        yield (0, myself_1.getUser)(apiUrl, TOKEN_KEY).then().catch((e) => console.log(e));
        (0, myself_1.showUserHeaderDetails)(base, '#logged-in-name', '#logged-in-username', '#logged-in-photo', TOKEN_KEY);
        const notificationAPIURL = `${authBase}/api/Notifications/Count`;
        (0, myself_1.updateNotificationBell)(notificationAPIURL, TOKEN_KEY, notificationAPIURL).then().catch((e) => console.log(e));
    });
}
document.addEventListener('DOMContentLoaded', () => __awaiter(void 0, void 0, void 0, function* () {
    init(`${authBase}/api/auth/login`);
}));
//# sourceMappingURL=app.js.map